import { ro } from "date-fns/locale";
import { columns } from "../../../dtos/columns";
import Conversiones from "../../../utils/conversiones";
import { ComportamientoPago } from "../models/comportamiento";

interface IProps {
    controlTabla: any;
}

export function useColumns({ controlTabla }: IProps) {
    const COLUMNS: columns<ComportamientoPago>[] = [
        {
            name: 'N° Dividendo',
            selector: (row) =>
                row.numeroDividendo,
            sortable: true,
            sortField: 'numeroDividendo',
            wrap: true,
            export: true
        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Forma pago',
            selector: (row) => row.nombreRecaudador ? row.nombreRecaudador.toString() : null,
            sortable: true,
            sortField: 'formaPago',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha vencimiento',
            selector: (row) => row.fechaVencimiento ? Conversiones.fechaCortaFormat(row.fechaVencimiento.toString()) : '',
            sortable: true,
            sortField: 'fechaVencimiento',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Fecha pago',
            selector: (row) => row.fechaPago ? Conversiones.fechaCortaFormat(row.fechaPago.toString()) : "",
            sortable: true,
            sortField: 'fechaContabilizacion',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Amortización normal',
            selector: (row) =>
                row.amortizacionDividendo != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.amortizacionDividendo)}`
                    : 0,
            sortable: true,
            sortField: 'amortizacionDividendo',
            wrap: true,
            export: true,
        },
        {
            name: 'Amortización normal',
            selector: (row) => {
                const value = row.amortizacionRecaudada;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            },
            sortable: true,
            sortField: 'amortizacionRecaudada',
            wrap: true,
            export: true,
        },
        {
            name: 'Amortización extraordinaria',
            selector: (row) => {
                const value = row.amortizacionExtraRecaudada;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'amortizacionExtraRecaudada',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Amortización extraordinaria',

            selector: (row) =>
                row.amortizacionExtraMO != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.amortizacionExtraMO)}`
                    : 0,
            sortable: true,
            sortField: 'amortizacionExtraMO',
            wrap: true,
            export: true,
        },
        {
            name: 'Interés',

            selector: (row) =>
                row.interesDividendo != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.interesDividendo)}`
                    : 0,
            sortable: true,
            sortField: 'interesDividendo',
            wrap: true,
            export: true,
        },
        {
            name: 'Interés recaudado',

            selector: (row) => {
                const value = row.interesRecaudado;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'interesRecaudado',
            wrap: true,
            export: true,
        },
        {
            name: 'Seguro incendio',

            selector: (row) =>
                row.seguroIncendio != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.seguroIncendio)}`
                    : 0,
            sortable: true,
            sortField: 'seguroIncendio',
            wrap: true,
            export: true,
        },
        {
            name: 'Seguro incendio',

            selector: (row) => {
                const value = row.seguroIncendioCal;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'seguroIncendioCal',
            wrap: true,
            export: true,
        },
        {
            name: 'Seguro desgravamen',

            selector: (row) =>
                row.seguroDesgravamen != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.seguroDesgravamen)}`
                    : 0,
            sortable: true,
            sortField: 'seguroDesgravamen',
            wrap: true,
            export: true,
        },
        {
            name: 'Seguro desgravamen',

            selector: (row) => {
                const value = row.seguroDesgravamenCal;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'seguroDesgravamenCal',
            wrap: true,
            export: true,
        },
        {
            name: 'Seguro cesantia',

            selector: (row) =>
                row.seguroCesantia != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.seguroCesantia)}`
                    : 0,
            sortable: true,
            sortField: 'seguroCesantia',
            wrap: true,
            export: true,
        },
        {
            name: 'Seguro cesantia',
            selector: (row) => {
                const value = row.seguroCesantiaCal;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'seguroCesantiaCal',
            wrap: true,
            export: true,
        },
        {
            name: 'Otros seguros',
            selector: (row) =>
                row.otrosSeguros != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.otrosSeguros)}`
                    : 0,
            sortable: true,
            sortField: 'otrosSeguros',
            wrap: true,
            export: true,
        },
        {
            name: 'Otros seguros',

            selector: (row) => {
                const value = row.otrosSegurosCal;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'otrosSegurosCal',
            wrap: true,
            export: true,
        },
        {
            name: 'Home life',

            selector: (row) =>
                row.homeLife != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.homeLife)}`
                    : 0,
            sortable: true,
            sortField: 'homeLife',
            wrap: true,
            export: true,
        },
        {
            name: 'Home life',

            selector: (row) => {
                const value = row.homeLifeCal;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'homeLifeCal',
            wrap: true,
            export: true,
        },
        {
            name: 'Sucursal pago',

            selector: (row) =>
                row.sucursalPago ? row.sucursalPago.toString() : null,
            sortable: true,
            sortField: 'sucursalPago',
            wrap: true,
            export: true,
        },
        {
            name: 'Interés penal',

            selector: (row) => {
                const value = row.interesPenal;
                return typeof value === 'number' && !isNaN(value)
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(value)}`
                    : 'UF 0,00';
            }, sortable: true,
            sortField: 'interesPenal',
            wrap: true,
            export: true,
        },
        {
            name: 'Interés penal',

            selector: (row) => {
                const value = row.interesPenalRecaudado;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'interesPenalRecaudado',
            wrap: true,
            export: true,
        },
        {
            name: 'Gastos cobranza',

            selector: (row) =>
                row.gastosCobranzaRecaudado != null
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(row.gastosCobranzaRecaudado)}`
                    : '$ 0,00',
            sortable: true,
            sortField: 'gastosCobranzaRecaudado',
            wrap: true,
            export: true,
        },
        {
            name: 'Ajuste',

            selector: (row) => {
                const value = row.ajustePesos;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'ajustePesos',
            wrap: true,
            export: true,
        },
        {
            name: 'Total dividendos',

            selector: (row) => {
                const value = row.totalDividendo;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'totalRecaudado',
            wrap: true,
            export: true,
        },
        {
            name: 'Total dividendos',

            selector: (row) =>
                row.totalMO != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.totalMO)}`
                    : 0,
            sortable: true,
            sortField: 'totalMO',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha contabilizacion',
            selector: (row) => row.fechaContabilizacion ? Conversiones.fechaCortaFormat(row.fechaContabilizacion.toString()) : "",
            sortable: true,
            sortField: 'fechaContabilizacion',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Fecha remesa',
            selector: (row) => row.fechaRemesa ? Conversiones.fechaCortaFormat(row.fechaRemesa.toString()) : "",
            sortable: true,
            sortField: 'fechaRemesa',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Total real cancelado',

            selector: (row) => {
                const value = row.totalReal;
                return typeof value === 'number' && !isNaN(value)
                    ? `$ ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 0 }).format(value)}`
                    : '$ 0,00';
            }, sortable: true,
            sortField: 'totalReal',
            wrap: true,
            export: true,
        },
        {
            name: 'Saldo insoluto',
            selector: (row) =>
                row.saldoInsoluto != null
                    ? `UF ${new Intl.NumberFormat('es-CL', { minimumFractionDigits: 4 }).format(row.saldoInsoluto)}`
                    : 0,
            sortable: true,
            sortField: 'saldoInsoluto',
            wrap: true,
            export: true,
        }

    ]

    return { COLUMNS };
}